import axios from 'axios';

/**
 * Instancia axios compartida para llamadas a la API.
 *
 * Separado de `client.ts` (donde esta `useApi()`) para evitar un ciclo
 * de imports: `useApi()` necesita el hook de auth, `local-auth` necesita
 * un cliente HTTP para login/signup. Si ambos viven en el mismo modulo,
 * uno de los dos recibe undefined al importarse.
 *
 * Cuando MSW esta activo (VITE_ENABLE_MOCKS=true) usamos ruta relativa;
 * en modo real apuntamos al backend en :3000.
 */
const USE_MOCKS = import.meta.env.VITE_ENABLE_MOCKS === 'true';
const API_BASE = USE_MOCKS
  ? ''
  : import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});
